<template>
	<div
		class="nejpripo-data"
	>
		<span class="company-name"> Vodafone: </span>
		<div v-if="loading">
			<tile :loading="loading" :height="'4'" :width="'4'" class="loading-icon"></tile>
		</div>
		<div v-else-if="results.length">
			<div v-for="(product, index) of results" :key="index" class="vodafone-product">
				<div>
					<h4 style="display: flex"> ({{ product.productType }}) - {{ product.productInfo.name }}  {{ product.productInfo.offeringPrice.monthly}} Kč <button :class="['btn', showProducts.includes(index) ? 'btn-secondary' : 'btn-primary']" style="margin-left: auto" @click="() => switchProduct(index)">{{ showProducts.includes(index) ? '-' : '+'}}</button></h4>
					<div style="display: flex; gap: 8px; flex-wrap: wrap;"> <div v-for="(tag, index) of product.productInfo.tags" :key="index" class="tag"> {{ tag.label }} </div> </div>
					<div v-show="showProducts.includes(index)">
						<div style="display: flex; line-height: 30px; gap: 8px; color: black !important;">
							Popis: <div v-html="product.productInfo.shortDescription">  </div>
						</div>
						<div style="display: flex; line-height: 30px; gap: 8px;"> <div v-html="product.productInfo.productBox"></div></div>
						<div style="display: flex; line-height: 30px; gap: 8px;"> <div v-html="product.productInfo.productHighlights"></div></div>
						<div style="display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 8px;"> <div> Cena nabídky: <b> {{ product.productInfo.offeringPrice.monthly }} Kč </b> </div> <div v-if="product.productInfo.offeringPrice.originalMonthly" style="text-decoration: line-through"> ({{ product.productInfo.offeringPrice.originalMonthly}} Kč )</div> <div v-if="product.productInfo.offeringPrice.promoText">(Promotext: {{ product.productInfo.offeringPrice.promoText}}) </div></div>
						<div v-if="product.productInfo.offeringPrice.discount"> Sleva: {{product.productInfo.offeringPrice.discount.amount}}Kč ({{ product.productInfo.offeringPrice.discount.discountType}}) </div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'NejPripoResult',

	props: {
		results: { type: Array, default: [] },
		loading: { type: Boolean }
	},


	data () {
		return {
			show: false,
			showProducts: [],
		}
	},

	methods: {
		switchProduct(index) {
			if (!this.showProducts.includes(index)) {
				this.showProducts.push(index)
				return
			}
			this.showProducts = this.showProducts.filter((item) => item !== index)
		}
	}

}
</script>

<style lang="stylus" scoped>
.vodafone-product
	background-color white
	border-radius 5px
	margin-bottom 5px
	padding 10px

.tag
	padding-left 5px
	padding-right 5px
	padding-top 3px
	padding-bottom 3px
	background-color #dedad9
	border-radius 3px



.first-text
	font-size 20px

.nejpripo-data
	padding-top 10px
	border-bottom 1px solid #4CA5F9
	border-top 1px solid #4CA5F9

.company-name
	font-weight bold
	font-size 24px


.nejpripo-vysledek
	display flex
	flex-direction column
	border-bottom 1px dashed #4CA5F9
	border-top 1px dashed #4CA5F9
	padding-bottom 10px
	padding-top 10px

.cetin-vysledek-card
	padding 10px
	background-color white
	border-radius 5px
	margin-right 10px
	margin-bottom 10px

.zmensit
	width 400px

.loading
	height 50px
	padding 0px

.loading-icon
	height 50px
	padding 0px !important
	margin-top -100px !important


@media (max-width 1000px)
	.zmensit
		width 100%

</style>



// WEBPACK FOOTER //
// src/components/search_provider/results/VodafoneResult.vue